var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42DSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M47.003 37.5a1.5 1.5 0 0 1-1.5 1.5h-31a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h31a1.5 1.5 0 0 1 1.5 1.5v15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35 6h10l.752 8.274A2.5 2.5 0 0 1 43.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L35 6Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m34 8 .223-.445A2.813 2.813 0 0 1 36.738 6h6.524c1.065 0 2.039.602 2.515 1.555L46 8"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 54H15l-.752-8.274A2.5 2.5 0 0 1 16.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L25 54Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m26 52-.223.445A2.813 2.813 0 0 1 23.262 54h-6.524a2.813 2.813 0 0 1-2.515-1.555L14 52"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M15 6h10l.752 8.274A2.5 2.5 0 0 1 23.262 17h-6.524a2.5 2.5 0 0 1-2.49-2.726L15 6Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m14 8 .223-.445A2.813 2.813 0 0 1 16.738 6h6.524c1.065 0 2.039.602 2.515 1.555L26 8"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M45 54H35l-.752-8.274A2.5 2.5 0 0 1 36.738 43h6.524a2.5 2.5 0 0 1 2.49 2.726L45 54Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m46 52-.223.445A2.813 2.813 0 0 1 43.262 54h-6.524a2.813 2.813 0 0 1-2.515-1.555L34 52"
})));
SvgRectangle42DSelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42DSelected);
export default ForwardRef;